import { render, staticRenderFns } from "./LostLeadModal.vue?vue&type=template&id=355f0714&scoped=true"
import script from "./LostLeadModal.vue?vue&type=script&lang=js"
export * from "./LostLeadModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355f0714",
  null
  
)

export default component.exports